/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5dd
import { getUnqualifiedItems } from '@tcp/core/src/services/abstractors/CnC/CartItemTile';
import { getEddSessionState, readCookie } from '@tcp/core/src/utils';
import { getDateObject, getDateRange } from '@tcp/core/src/utils/utils';
import verifyAddressData from '@tcp/core/src/services/abstractors/account/AddressVerification';
import { sites } from '@tcp/web/src/constants/constants';
import { updateShippingAddressMethodAndGiftOption } from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import {
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
  ORDER_TYPE,
} from '../../../../features/CnC/Checkout/Checkout.constants';
import { addEditStoreDetailsApi } from '../../../../../services/abstractors/SFCC/addEditStoreDetails';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../../../features/CnC/BagPage/container/Bagpage.labels';
import BAGPAGE_CONSTANTS from '../../../../features/CnC/BagPage/BagPage.constants';
import { checkForFreeShipping } from '../../../../features/CnC/BagPage/views/Bagpage.utils';

export const APPLE_USER_STATES = {
  GUEST: 'G',
  REGISTERED: 'R',
};

export const ErrorCodes = {
  INCORRECT_SHIPMODE_ID: 'INCORRECT_SHIPMODE_ID',
  ERR_US_ZIPCODE_INVALID: '_ERR_US_ZIPCODE_INVALID',
  ERR_INVALID_CITY: 'ERR_INVALID_CITY',
};

export const appleLabel = {
  APPLE_PAY: 'APPLE_PAY',
};

export const shouldDisplayEDD = ({ isEddABTest, isEDD }) => {
  return getEddSessionState(isEddABTest) && isEDD;
};

export const formatShippingMethods = (
  shipmentMethods,
  defaultShipModeId,
  shippingTotal,
  isDynamicFreeShippingEnabled,
  shipments,
  freeShippingThershold,
  orderType,
  productTotal,
  otherProps
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const { orderEddDates = {}, isEDD = false, isEddABTest = false } = otherProps || {};
  const shouldViewEDD = shouldDisplayEDD({ isEddABTest, isEDD });
  const { lbl_edd_arrivesby: arrivesBy } = getLabelFromCopyOrFromTranslation(
    'checkout.bagPage',
    BAGPAGE_LABELS
  );
  const selectedShipmentCode = shipmentMethods?.find((method) => method?.id === defaultShipModeId);
  const items = shipmentMethods.map((item) => {
    const isFreeShippingEligible = checkForFreeShipping({
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      freeShippingThershold,
      selectedShipmentCode: selectedShipmentCode?.code,
      orderType,
      productTotal,
    });
    const rangeDate = orderEddDates ? getDateRange(orderEddDates, item.code) : null;
    const detail = shouldViewEDD && rangeDate ? `${arrivesBy} ${rangeDate}` : item.shippingSpeed;
    let amount;
    if (BAGPAGE_CONSTANTS?.FREE_SHIPMENT_CODES.includes(item?.code)) {
      amount = isFreeShippingEligible ? '0' : (item?.price || 0)?.toFixed(2)?.toString();
    } else {
      amount = (item?.price || 0)?.toFixed(2)?.toString();
    }

    return {
      label: item?.displayName ? item.displayName?.split(' - ')?.[0] : '',
      detail,
      amount,
      identifier: item.id,
    };
  });
  // move default shipping Method to top
  const sm = items.filter((item) => item.identifier !== defaultShipModeId);
  const defaultShipMethod = items.filter((item) => item.identifier === defaultShipModeId);
  if (defaultShipMethod && defaultShipMethod.length > 0) {
    sm.unshift(defaultShipMethod[0]);
  }
  return sm;
};

export const getStoreAddress = (addressObject) => {
  const {
    addressLine1 = '',
    city = '',
    state = '',
    zipCode = '',
    country = '',
  } = addressObject || {};
  return {
    addressLine1,
    city,
    state,
    zipCode,
    country,
  };
};

export const formatShippingMethodsForBopisBoss = (stores, aydenPayment) => {
  const isValidStoreType = Array.isArray(stores);
  const firstStore = isValidStoreType && stores[0];
  const secondStore = isValidStoreType && stores[1];
  const storeCount = (isValidStoreType && stores.length) || 0;

  const { addressLine1, city, state, zipCode, country } = getStoreAddress(firstStore);
  const { stLocId = '', storeName = '' } = firstStore || {};
  const sameStore = stLocId === (secondStore && secondStore.stLocId); // max stores can only be 2 for any order
  const singleOrSameStore = storeCount === 1 || sameStore;
  const labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);
  const baseMethod = {
    label: singleOrSameStore
      ? `${renderLabel(labelsObj.lbl_applepay_pickUpAt, 'lbl_applepay_pickUpAt')} ${storeName}`
      : renderLabel(labelsObj.lbl_applepay_multipleLocations, 'lbl_applepay_multipleLocations'),
    detail: singleOrSameStore ? `${addressLine1} ${city} ${state} ${zipCode} ${country}` : '',
    amount: aydenPayment ? '0.00' : '0',
    identifier: 'bopisOrBoss',
  };
  // Only add type field for Adyen payments
  const method = aydenPayment ? { ...baseMethod, type: 'store-pickup' } : baseMethod;

  return [method];
};

export const getLineItems = (pageLedgerSummaryData) => {
  const lineItems = [];
  let lineItem = {};
  const {
    subTotal,
    taxesTotal,
    shippingTotal,
    couponsTotal,
    giftCardsTotal,
    giftServiceTotal,
    savingsTotal,
  } = pageLedgerSummaryData;
  const totalDiscounts = couponsTotal + savingsTotal;
  const labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);
  const globalGenericLabelsObj = getLabelFromCopyOrFromTranslation(
    'global.generic',
    BAGPAGE_LABELS
  );
  lineItem = {
    type: 'final',
    label: renderLabel(labelsObj.lbl_applepay_subTotal, 'lbl_applepay_subTotal'),
    amount: (subTotal || 0).toFixed(2).toString(),
  };
  lineItems.push(lineItem);
  if (giftServiceTotal && giftServiceTotal > 0) {
    lineItem = {
      type: 'final',
      label: renderLabel(labelsObj.lbl_orderledger_giftServices, 'lbl_orderledger_giftServices'),
      amount: `${giftServiceTotal.toFixed(2).toString()}`,
    };
    lineItems.push(lineItem);
  }
  lineItem = {
    type: 'final',
    label: renderLabel(labelsObj.lbl_applepay_estimatedTax, 'lbl_applepay_estimatedTax'),
    amount: (taxesTotal || 0).toFixed(2).toString(),
  };
  lineItems.push(lineItem);
  lineItem = {
    type: 'final',
    label: renderLabel(globalGenericLabelsObj.lbl_shipping, 'lbl_shipping'),
    amount: (shippingTotal || 0).toFixed(2).toString(),
  };
  lineItems.push(lineItem);
  if (totalDiscounts && totalDiscounts > 0) {
    lineItem = {
      type: 'final',
      label: renderLabel(labelsObj.lbl_applepay_discounts, 'lbl_applepay_discounts'),
      amount: `-${totalDiscounts.toFixed(2).toString()}`,
    };
    lineItems.push(lineItem);
  }
  if (giftCardsTotal && giftCardsTotal > 0) {
    lineItem = {
      type: 'final',
      label: renderLabel(labelsObj.lbl_orderledger_giftcards, 'lbl_orderledger_giftcards'),
      amount: `-${giftCardsTotal.toFixed(2).toString()}`,
    };
    lineItems.push(lineItem);
  }
  return lineItems;
};

export const getTotal = (orderBalanceTotal, type) => {
  return {
    label: getDynamicLabelValues('dynamic.checkout_d.lbl_applepay_totalAmount'),
    type,
    amount: (orderBalanceTotal || 0).toFixed(2).toString(),
  };
};
export const getLedgerSummaryData = (cart) => {
  const {
    orderDetails: {
      subTotal,
      totalTax,
      applePayShippingTotal,
      couponsTotal,
      grandTotal,
      giftCardsTotal,
      giftWrappingTotal,
      savingsTotal,
      applePayDisc = 0,
    },
  } = cart;
  return {
    subTotal: subTotal || 0,
    taxesTotal: totalTax || 0,
    shippingTotal: applePayShippingTotal || 0,
    couponsTotal: (couponsTotal || 0) + (applePayDisc || 0),
    savingsTotal: savingsTotal || 0,
    giftServiceTotal: giftWrappingTotal || 0,
    giftCardsTotal: giftCardsTotal || 0,
    orderBalanceTotal: (grandTotal || 0) - (giftCardsTotal || 0) - (applePayDisc || 0),
  };
};

export const getUnqualifiedItemsCall = () => {
  return getUnqualifiedItems().then((res) => {
    const response = res || [];
    response.status = response.length > 0;
    return response;
  });
};

const getAddressLines = (addressLines) => {
  const addressLine1 = (addressLines && addressLines.length > 0 && addressLines[0]) || '';
  const addressLine2 = (addressLines && addressLines.length > 1 && addressLines[1]) || '';
  return [addressLine1, addressLine2];
};

export const getUpdateShippingPayload = (shippingContact, shipModeId, toggleShipMode) => {
  const {
    addressLines,
    postalCode,
    administrativeArea,
    locality,
    countryCode,
    familyName,
    givenName,
    emailAddress,
    phoneNumber,
    addressId = 0,
  } = shippingContact;
  return {
    shipModeId,
    toggleShipMode,
    contact: [
      {
        addressLine: [...getAddressLines(addressLines), ''],
        city: locality,
        country: countryCode && countryCode.toUpperCase(),
        email1: emailAddress || '',
        firstName: givenName,
        lastName: familyName,
        nickName: `${'sb_'}${getDateObject().getTime().toString()}`,
        phone1: phoneNumber || '',
        state: administrativeArea && administrativeArea.toUpperCase(),
        zipCode: postalCode,
      },
    ],
    fromPage: 'applePaySheet',
    addressId,
  };
};

export const getAddressPayload = (shippingContact) => {
  const { familyName, givenName, emailAddress, phoneNumber, addressId = 0 } = shippingContact;
  return {
    emailAddress: emailAddress || '',
    email2: '',
    firstName: givenName,
    lastName: familyName,
    phoneNumber: phoneNumber || '',
    addressId,
  };
};

export const getPaySheetError = (resultCodes, errorCode, field, message, errors = []) => {
  if (resultCodes.includes(errorCode)) {
    errors.push(new window.ApplePayError('shippingContactInvalid', field, message));
  }
  return errors;
};

export const verifyMellisaAddress = (isMellisaValidationCompleted, shippingContact) => {
  if (isMellisaValidationCompleted) {
    return new Promise((resolve) => {
      resolve({
        status: true,
        isMellisaValidationCompleted: true,
        errors: [],
      });
    });
  }

  const errors = [];
  const { addressLines, locality, postalCode, countryCode, administrativeArea } = shippingContact;
  const contact = {
    address1: addressLines[0],
    address2: addressLines[1],
    city: locality,
    zip: postalCode,
    country: countryCode.toUpperCase(),
    state: administrativeArea.toUpperCase(),
  };

  const labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

  return verifyAddressData(contact).then((res) => {
    const { resultCodes } = res;
    const fieldMapping = {
      streetField: 'addressLines',
    };

    getPaySheetError(
      resultCodes,
      'AE02',
      fieldMapping.streetField,
      renderLabel(labelsObj.lbl_applepay_invalid_street_name, 'lbl_applepay_invalid_street_name'),
      errors
    );
    getPaySheetError(
      resultCodes,
      'AE09',
      fieldMapping.streetField,
      renderLabel(labelsObj.lbl_applepay_invalid_house_number, 'lbl_applepay_invalid_house_number'),
      errors
    );
    return {
      status: errors.length === 0,
      isMellisaValidationCompleted: true,
      errors,
    };
  });
};

export const isValidShippingAddress = (allowedStates, shippingContact) => {
  const { countryCode, administrativeArea } = shippingContact;
  const labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);
  const errors = [];
  if (
    allowedStates &&
    allowedStates.length > 0 &&
    allowedStates.toUpperCase().indexOf(administrativeArea.toUpperCase()) === -1
  ) {
    errors.push(
      new window.ApplePayError(
        'shippingContactInvalid',
        'administrativeArea',
        renderLabel(
          labelsObj.lbl_applepay_nonEligibleStateErrorMessage,
          'lbl_applepay_nonEligibleStateErrorMessage'
        )
      )
    );
  } else if (countryCode.toUpperCase() !== sites.us.countryCode) {
    errors.push(
      new window.ApplePayError(
        'shippingContactInvalid',
        'country',
        renderLabel(
          labelsObj.lbl_applepay_nonEligibleCountryErrorMessage,
          'lbl_applepay_nonEligibleCountryErrorMessage'
        )
      )
    );
  }
  return {
    status: errors.length === 0,
    errors,
  };
};

export const errorType = (errors, typeCode, field, message) => {
  const labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

  errors.push(
    new window.ApplePayError(typeCode, field, renderLabel(`${labelsObj[message]}`, `${message}`))
  );
};

export const compareValues = (fieldValue) => {
  return fieldValue === '' || fieldValue === 'null' || !fieldValue;
};

export const isCompleteContactInPaysheet = (shippingContact, isOptimizeApplePaySheetEnabled) => {
  const errors = [];
  if (!isOptimizeApplePaySheetEnabled) {
    const { familyName, givenName, phoneNumber, emailAddress } = shippingContact;
    if (compareValues(familyName) || compareValues(givenName)) {
      errorType(errors, 'shippingContactInvalid', 'name', 'lbl_applepay_noLastNameErrorMessage');
    } else if (compareValues(phoneNumber)) {
      errorType(
        errors,
        'shippingContactInvalid',
        'phoneNumber',
        'lbl_applepay_noPhoneNumberErrorMessage'
      );
    } else if (compareValues(emailAddress)) {
      errorType(
        errors,
        'shippingContactInvalid',
        'emailAddress',
        'lbl_applepay_noEmailAddressErrorMessage'
      );
    }
  }
  return {
    statusErr: errors.length === 0,
    errors,
  };
};

export const addAddressAndShippingMethod = async (shippingContact, orderType) => {
  const basketId = readCookie('basketId');
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return updateShippingAddressMethodAndGiftOption(shippingContact);
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    const { shippingObject, pickUpObj } = shippingContact;
    const response = await addEditStoreDetailsApi({ ...pickUpObj, basketId });
    if (response) {
      return updateShippingAddressMethodAndGiftOption(shippingObject);
    }
    return response;
  }
  // eslint-disable-next-line sonarjs/prefer-immediate-return
  const response = await addEditStoreDetailsApi({ ...shippingContact, basketId });
  return response;
};

export const shippingObjectAfterAuthorisation = (
  event,
  shipModeId,
  shippingContact,
  isOptimizeApplePaySheet
) => {
  const shippingContactEvent = isOptimizeApplePaySheet
    ? shippingContact
    : event?.payment?.shippingContact;
  return {
    shippingAddressDTO: {
      shippingAddress: {
        address1: shippingContactEvent?.addressLines[0],
        address2: shippingContactEvent?.addressLines[1],
        city: shippingContactEvent?.locality,
        postalCode: shippingContactEvent?.postalCode,
        countryCode: shippingContactEvent?.countryCode.toUpperCase(),
        stateCode: shippingContactEvent?.administrativeArea.toUpperCase(),
        c_emailAddress: shippingContactEvent.emailAddress,
        firstName: shippingContactEvent.givenName || '',
        lastName: shippingContactEvent.familyName || '',
        phone: shippingContactEvent.phoneNumber || '',
        c_addressType: 'ShippingAndBilling',
        c_addressId: shippingContactEvent.addressId || '',
      },
    },
    shippingMethod: {
      id: shipModeId,
    },
    fromAction: 'applepay',
  };
};

export const pickUpObjAfterAuthorisation = (
  event,
  pickUpValues,
  shippingContact,
  isOptimizeApplePaySheet,
  pickUpAlternatePerson
) => {
  const shippingContactEvent = isOptimizeApplePaySheet
    ? shippingContact
    : event?.payment?.shippingContact;

  return {
    firstName:
      pickUpValues && pickUpValues.firstName
        ? pickUpValues.firstName
        : shippingContactEvent?.givenName,
    lastName:
      pickUpValues && pickUpValues.lastName
        ? pickUpValues.lastName
        : shippingContactEvent?.familyName,
    email:
      pickUpValues && pickUpValues.emailAddress
        ? pickUpValues.emailAddress
        : shippingContactEvent?.emailAddress,
    phone:
      pickUpValues && pickUpValues.phoneNumber
        ? pickUpValues.phoneNumber
        : shippingContactEvent?.phoneNumber,
    c_altEmail: pickUpAlternatePerson && pickUpAlternatePerson?.emailAddress,
    c_altName:
      pickUpAlternatePerson &&
      `${pickUpAlternatePerson?.firstName ? pickUpAlternatePerson?.firstName : ''} ${
        pickUpAlternatePerson?.lastName ? pickUpAlternatePerson?.lastName : ''
      }`,
  };
};

export const getShippingContactPayload = ({
  event,
  orderType,
  pickUpValues,
  shipModeId,
  shippingContact,
  isOptimizeApplePaySheet,
  pickUpAlternatePerson,
}) => {
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return shippingObjectAfterAuthorisation(
      event,
      shipModeId,
      shippingContact,
      isOptimizeApplePaySheet
    );
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    return {
      shippingObject: shippingObjectAfterAuthorisation(
        event,
        shipModeId,
        shippingContact,
        isOptimizeApplePaySheet
      ),
      pickUpObj: pickUpObjAfterAuthorisation(
        event,
        pickUpValues,
        shippingContact,
        isOptimizeApplePaySheet,
        pickUpAlternatePerson
      ),
    };
  }
  return pickUpObjAfterAuthorisation(
    event,
    pickUpValues,
    shippingContact,
    isOptimizeApplePaySheet,
    pickUpAlternatePerson
  );
};

export const getShippingUpdatePayload = (event, orderType, pickUpValues) => {
  const shippingObject = {
    shippingAddressDTO: {
      shippingAddress: {
        address1: event?.method?.addressLines[0] || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1,
        address2: event?.method?.addressLines[1] || '',
        city: event?.method?.locality,
        postalCode: event?.method?.postalCode,
        countryCode: event?.method?.countryCode,
        stateCode: event?.method?.administrativeArea,
        c_emailAddress: event?.method?.emailAddress || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email,
        firstName: event?.method?.givenName || '',
        lastName: event?.method?.familyName || '',
        phone: event?.method?.phoneNumber || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone,
        c_addressType: 'ShippingAndBilling',
        c_addressId: '',
      },
    },
    fromAction: 'applepay',
  };
  const pickUpObj = {
    firstName: pickUpValues?.firstName || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName,
    lastName: pickUpValues?.lastName || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName,
    email: pickUpValues?.emailAddress || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email,
    phone: pickUpValues?.phoneNumber || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone,
  };
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return shippingObject;
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    return {
      shippingObject,
      pickUpObj,
    };
  }
  return pickUpObj;
};

export const getShippingUpdatePayloadWeb = (event, orderType, pickUpValues) => {
  const shippingObject = {
    shippingAddressDTO: {
      shippingAddress: {
        address1:
          event?.shippingContact?.addressLines?.[0] || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1,
        address2: event?.shippingContact?.addressLines?.[1] || '',
        city: event?.shippingContact?.locality,
        postalCode: event?.shippingContact?.postalCode,
        countryCode: event?.shippingContact?.countryCode,
        stateCode: event?.shippingContact?.administrativeArea,
        c_emailAddress:
          event?.shippingContact?.emailAddress || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email,
        firstName: event?.shippingContact?.givenName || '',
        lastName: event?.shippingContact?.familyName || '',
        phone: event?.shippingContact?.phoneNumber || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone,
        c_addressType: 'ShippingAndBilling',
        c_addressId: '',
      },
    },
    fromAction: 'applepay',
  };

  const pickUpObj = {
    firstName: pickUpValues?.firstName || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName,
    lastName: pickUpValues?.lastName || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName,
    email: pickUpValues?.emailAddress || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email,
    phone: pickUpValues?.phoneNumber || DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone,
  };
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return shippingObject;
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    return {
      shippingObject,
      pickUpObj,
    };
  }
  return pickUpObj;
};

export const setAppleShippingAddressAndMethodPayload = (
  shippingContact,
  shippingMethodId,
  orderType,
  pickUpValues
) => {
  const shippingObject = {
    shippingMethod: {
      id: shippingMethodId,
    },
    shippingAddressDTO: {
      shippingAddress: {
        address1: shippingContact?.addressLines[0],
        address2: shippingContact?.addressLines[1],
        city: shippingContact?.locality,
        postalCode: shippingContact?.postalCode,
        countryCode: shippingContact?.countryCode.toUpperCase(),
        stateCode: shippingContact?.administrativeArea.toUpperCase(),
        c_emailAddress: shippingContact?.emailAddress,
        firstName: shippingContact?.givenName || '',
        lastName: shippingContact?.familyName || '',
        phone: shippingContact?.phoneNumber || '',
        c_addressType: 'ShippingAndBilling',
        c_addressId: shippingContact?.addressId || '',
        c_phoneCountryCode: shippingContact?.phoneCountryCode || '',
        c_validationCode: shippingContact?.c_validationCode,
      },
    },
    fromAction: 'applepay',
  };
  const pickUpObj = {
    firstName: pickUpValues?.firstName || shippingContact?.givenName || '',
    lastName: pickUpValues?.lastName || shippingContact?.familyName || '',
    email: pickUpValues?.emailAddress || shippingContact?.emailAddress,
    phone: pickUpValues?.phoneNumber || shippingContact?.phoneNumber || '',
  };
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return shippingObject;
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    return {
      shippingObject,
      pickUpObj,
    };
  }
  return pickUpObj;
};
